import { useState, useCallback } from 'react';
import { Choice } from '../components/ChoiceBox/ChoiceBox';

export interface ChoiceScenario {
  question?: string;
  choices: Choice[];
  onSelect: (choiceId: string) => any;
  timeoutSeconds?: number;
  onTimeout?: () => void;
}

export const useChoice = () => {
  const [isChoiceVisible, setIsChoiceVisible] = useState(false);
  const [currentScenario, setCurrentScenario] = useState<ChoiceScenario | null>(null);

  const showChoice = useCallback((scenario: ChoiceScenario) => {
    setCurrentScenario(scenario);
    setIsChoiceVisible(true);
  }, []);

  const hideChoice = useCallback(() => {
    setIsChoiceVisible(false);
    // アニメーション完了後にクリア
    setTimeout(() => {
      setCurrentScenario(null);
    }, 300);
  }, []);

  const handleSelect = useCallback((choiceId: string) => {
    if (currentScenario) {
      currentScenario.onSelect(choiceId);
    }
    hideChoice();
  }, [currentScenario, hideChoice]);

  const handleTimeout = useCallback(() => {
    if (currentScenario?.onTimeout) {
      currentScenario.onTimeout();
    }
    hideChoice();
  }, [currentScenario, hideChoice]);

  return {
    isChoiceVisible,
    currentScenario,
    showChoice,
    hideChoice,
    handleSelect,
    handleTimeout,
  };
};